<template>
  <div :class="addClass">
    <mdb-stepper id="wizard-stepper" v-model="currentStep" :options="options"
                 :remove="false"
                 :steps="settingsStepper" buttons
                 @changeStep="stepChanged"
                 @submit="submit">
      <template #1>
        <h2>Please Select a Page Style</h2>
        <mdb-btn icon="plus-circle" @click="$emit('cancel')">Cancel Wizard</mdb-btn>
        <mdb-row class="m-4">
          <div v-for="(w,i) in wizardTypes" :key="i" class="col-lg-3 col-md-12 text-left d-flex align-self-stretch">
            <mdb-card class="mb-2">
              <mdb-card-header class="secondary-color">
                {{ w.name }}
              </mdb-card-header>
              <mdb-card-body>
                <div class="text-center mb-2">
                  <mdb-btn icon="check" @click="chooseStyle(w)" size="sm" rounded>Select</mdb-btn>
                </div>
                <div v-if="w.imageLocation != 'full' && w.imageLocation != 'background'" :style="{width: '100%'}">
                  <img v-if="w.image && w.imageLocation != 'bottom'"
                       :src="settings.staticImageUrl + '/placeholder-image.png'"
                       :style="{float: w.imageLocation, marginRight: '10px', border:'#f0f0f0 solid', width: '43%'}"/>
                  <h4 :class="'text-' + w.text">Heading</h4>
                  <p :class="'text-' + w.text">
                    Duis volutpat consectetur arcu eu ullamcorper. Donec interdum ultrices dolor ut imperdiet.
                  </p>
                  <div style="clear:both;">&nbsp;</div>
                </div>
                <div v-if="w.imageLocation == 'background'" >
                  <div class="card-image"
                       style="background-size: cover; min-height: 50px; background-image: url('https://images.groups.place/PROD_adb7f79bd96c476fb39cf581a1ffe5b4_vancouverbridge.jpg')">
                    <div class="text-white text-center rgba-stylish-strong py-2 px-2">
                      <div class="py-5">
                        <h5>Heading</h5>
                      </div>
                    </div>
                  </div>
                  <div>
                    Duis volutpat consectetur arcu eu ullamcorper. Donec interdum ultrices dolor ut imperdiet.
                  </div>
                </div>
                <img v-if="w.imageLocation == 'full' || w.imageLocation == 'bottom'"
                     :src="settings.staticImageUrl + '/placeholder-image.png'"
                     :style="{width: '100%'}"/>

              </mdb-card-body>
            </mdb-card>
          </div>
        </mdb-row>
      </template>
      <template #2>
        <div v-if="currentStyle && currentStyle.image && result.image">
          <mdb-row class="align-items-center">
            <mdb-col col="4">&nbsp;</mdb-col>
            <mdb-col col="4">
              <mdb-card>
                <mdb-card-header><h3>Image Selected</h3></mdb-card-header>
                <mdb-card-image :src="result.image"/>
                <mdb-card-footer>
                  <mdb-btn icon="image" @click="imageSelector=true">Change Image</mdb-btn>
                  <mdb-btn icon="check" @click="nextStep">Use This Image</mdb-btn>
                </mdb-card-footer>
              </mdb-card>
            </mdb-col>
          </mdb-row>
        </div>
        <div v-if="currentStyle && !currentStyle.image">
          <h3>This style doesn't include an image.</h3>
        </div>
        <div v-if="!currentStyle">
          <h3>Please select a style first.</h3>
        </div>

      </template>

      <template #3>
        <div v-if="currentStyle && currentStyle.text != 'none'">
          <mdb-card class="m-4">
            <mdb-card-header><h3>Text</h3></mdb-card-header>
            <mdb-card-body>
              <div v-if="!currentStyle">
                <h3>Please select a style first.</h3>
              </div>
              <div v-if="currentStyle && currentStyle.text == 'none'">
                <h3>This style doesn't have text.</h3>
              </div>
              <div>
                <mdb-input id="heading-input" v-model="result.header" label="Heading/Title" placeholder="Heading"
                           type="text"/>
                <mdb-input v-model="result.body" :rows="7" label="Body" placeholder="Text" type="textarea"/>
              </div>
            </mdb-card-body>
            <mdb-card-footer>
              <mdb-btn icon="check" @click="submit">Generate Page</mdb-btn>
            </mdb-card-footer>
          </mdb-card>
        </div>
      </template>
      <template #4>
        <div v-if="currentStyle && currentStyle.text != 'none'">
          <mdb-card>
            <mdb-card-header><h3>All Set!</h3></mdb-card-header>
            <mdb-card-body>
              Click "Create Page" below to generate your new page.
            </mdb-card-body>
          </mdb-card>
        </div>
      </template>

    </mdb-stepper>

    <mdb-modal :show="imageSelector" @close="imageSelector = false">
      <mdb-modal-header :close="true" center class="primary-color text-white"><h4>Select an Image</h4>
      </mdb-modal-header>
      <mdb-modal-body>
        <image-selector :group="group" emitOnSelection="imageSelected" @imageSelected="imageSelected"/>
        <!--system-image-selector v-if="!group" :group="group" emitOnSelection="imageSelected"
                               @imageSelected="imageSelected"/>  -->
      </mdb-modal-body>
    </mdb-modal>

  </div>

</template>

<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbStepper
} from 'mdbvue';
import ImageSelector from "../group/ImageSelector";
import SystemImageSelector from "../admin/SystemImageSelector";

export default {
  name: 'Editor-Wizard',
  components: {
    mdbInput,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardImage,
    mdbCardBody,
    mdbStepper,
    mdbCardFooter,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    ImageSelector,
    SystemImageSelector
  },
  data() {
    return {
      currentStyle: null,
      result: {
        header: "",
        body: "",
        image: "",
        html: ""
      },
      wizardTypes: [
        {name: 'Jumbotron with Image', image: true, imageLocation: "background", text: "center"},
        {name: 'Image Left, Text Left', image: true, imageLocation: "left", text: "left"},
        {name: 'Image Left, Text Center', image: true, imageLocation: "left", text: "center"},
        {name: 'Image Right, Text Left', image: true, imageLocation: "right", text: "left"},
        {name: 'Image Right, Text Center', image: true, imageLocation: "right", text: "center"},
        {name: 'No Image, Text Left', image: false, imageLocation: null, text: "left"},
        {name: 'No Image, Text Center', image: false, imageLocation: null, text: "center"},
        {name: 'Image Only', image: true, imageLocation: "full", text: "none"},
        {name: 'Image Bottom, Text Left', image: true, imageLocation: "bottom", text: "left"},
        {name: 'Image Bottom, Text Center', image: true, imageLocation: "bottom", text: "center"},
      ],
      imageSelector: false,
      currentStep: 1,
      step1Complete: false,
      step2Complete: false,
      step3Complete: false,
      step4Complete: false,
      settingsStepper: [
        {icon: "file", far: true, name: "Page Type"},
        {icon: "image", far: true, name: "Image"},
        {icon: "pencil-alt", name: "Text"},
        {icon: "check", name: "Finish"}
      ],
      options: {
        stepBtn: {color: "info", active: "amber", iconClass: "white-text"},
        nextBtn: {outline: "info", icon: "chevron-right"},
        prevBtn: {outline: "info", icon: "chevron-left"},
        submitBtn: {color: "amber", icon: "check", text: "Create Page"},
        lineColor: "amber"
      },
    }
  },
  props: {
    addClass: {
      type: String,
      default: null
    },
    group: {
      type: Object,
      default: null
    },
    prefill: {
      type: Object,
      default: null
    },
    scrollTop: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    settings() {
      return this.$store.state.settings
    }
  },
  mounted() {
    if (this.scrollTop) window.scrollTo(0, 0)
    if (this.prefill) {
      this.result = this.prefill
    }

  },
  methods: {
    stepChanged(s) {
      if (s == 3) {
        let el = document.getElementById("heading-input")
        if (el) {
          this.$nextTick().then(() => {
            el.focus()
          })
        }
      }
    },
    nextStep() {
      if (this.currentStep == 2 && this.currentStyle.text == "none") {
        this.submit()
      } else if (this.currentStep == 2) {
        this.currentStep = 3
      }
    },
    submit() {
      let html
      if (this.currentStyle.image && this.result.image && this.currentStyle.imageLocation == "background") {
        html = "<div class=\"card card-image\" style=\"background-image: url('" + this.result.image +
          "');\"><div class=\"text-white text-center rgba-stylish-strong py-5 px-4\"><div class=\"py-5\">";
        if (this.result.header) {
          html += "<h2>" + this.result.header + "</h2>"
        }
        html += "</div></div></div>"
        if (this.result.body) {
          html += "<div>" + this.result.body + "</div>"
        }

      } else {
        html = "<div>"
        if (this.currentStyle.image && this.result.image) {
          if (this.currentStyle.imageLocation == "left" ||
            this.currentStyle.imageLocation == "right") {
            html += "<img src='" + this.result.image + "' style='width: 33%;' class='gp-user-image-" + this.currentStyle.imageLocation + "'/>";
          }
          if (this.currentStyle.imageLocation == "full") {
            //html += "<div><img src='" + this.result.image + "' class='gp-user-image-center' style='width: 80%;' /></div>"
            html += "<div class=\"card wizard-full-image-container rare-wind-gradient\"><div class=\"card-body wizard-full-image\" style=\"background-image: url('" + this.result.image + "');\">&nbsp;</div></div>"

          }
        }
        if (this.result.header) {
          let pTag = "<p class='gp-user-text-125'>"
          if (this.currentStyle.text == "center") pTag = "<p class='text-center gp-user-text-125'>"
          html += pTag + this.result.header + "</p>"
        }
        if (this.result.body) {
          let pTag = "<p>"
          if (this.currentStyle.text == "center") pTag = "<p class='text-center'>"
          let paragraphs = this.result.body.split("\n")
          for (let p of paragraphs) {
            if (p) {
              html += pTag + p + "</p>"
            }
          }
        }
        if (this.currentStyle.imageLocation == "left" ||
          this.currentStyle.imageLocation == "right") {
          html += "<p>&nbsp;</p><p>&nbsp;</p><div class='gp-end-wrap'>&nbsp;</div>"
        }
        if (this.currentStyle.imageLocation == "bottom") {
          html += "<p style='text-align:center;'><img src='" + this.result.image + "' style='width: 80%;'/></p>"
        }
      }
      this.result.html = html
      this.$emit("pageGenerated", this.result)

    },
    chooseStyle(w) {
      this.currentStyle = w
      if (w.image) this.currentStep = 2
      else this.currentStep = 3
      if (this.scrollTop) window.scrollTo(0, 0)
      if (!this.result.image && w.image) this.imageSelector = true
    },
    imageSelected(i) {
      this.result.image = i.url;
      this.imageSelector = false;
    }
  }
}
;
</script>

